const commonMutations = {
  getUser: (state, res) => {
    state.user = res;
  },
  getAddress: (state, res) => {
    state.Address = res;
  }
};
export default commonMutations;
